// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Section_elSection__2AZgk {\n  margin-bottom: 16px; }\n\n.Section_warningModal__2yAaE {\n  width: 450px !important; }\n", ""]);
// Exports
exports.locals = {
	"elSection": "Section_elSection__2AZgk",
	"warningModal": "Section_warningModal__2yAaE"
};
module.exports = exports;
